/**
 * Custom error class for maintenance mode
 */
export class MaintenanceError extends Error {
  public readonly maintenance: boolean = true;

  constructor(message: string) {
    super(message);
    this.name = "MaintenanceError";
  }
}

/**
 * Type guard to check if an error is a maintenance error
 */
export function isMaintenanceError(error: unknown): error is MaintenanceError {
  return error instanceof MaintenanceError;
}
